import { LastStateFromServer } from '../../api';
import { ActualSchema } from './versions';

export type LastStateShape = {
  appliedId: number | null;
};

export const parseLocationStateId = () => {
  const url = new URL(window.location.href);
  const stateId = url.searchParams.get('state_id');
  return Number(stateId) || null;
};

// Deep link from Creative Hub ("Open in Asset Lab"): the target project and
// (optional) category are passed as query params (before the hash, like state_id).
export const parseLocationHighlightProjectId = () => {
  const url = new URL(window.location.href);
  const id = url.searchParams.get('highlight_project_id');
  return Number(id) || null;
};

export const parseLocationHighlightCategoryId = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get('highlight_category_id');
};

export const parseLocationHighlightAssetId = () => {
  const url = new URL(window.location.href);
  const id = url.searchParams.get('highlight_asset_id');
  return Number(id) || null;
};

export type LastState = LastStateFromServer & { state: ActualSchema };
